export default {
	jan: 'មករា',
    feb: "កុម្ភៈ",
    mar:"មិនា",
    apr:'មេសា',
    may:"ឧសភា",
    jun:"មិថុនា",
    jul:'កក្កដា',
    aug:'សីហា',
    sep:"កញ្ញា",
    oct:"តុលា",
    nov:"វិច្ឆិកា",
    dec:"ធ្មូ"
}